import styled from "styled-components"
import { AosWrapper } from "../../molecules/AosWrapper"
import { Descripition, GradientText, Headline } from "../../../utils"

const Wrapper = styled.div`
  padding: 80px 20px;
  background-color: ${(props) => props.theme.footerSectionColor};
  @media (min-width: 601px) and (max-width: 1023px) {
    padding: 50px 60px;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }
  @media (min-width: 1200px) {
    padding: 80px 136px;
  }
`

const Container = styled.div`
  padding: 0px 100px;

  @media only screen and (max-width: 768px) {
    padding: 0px;
  }
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (max-width: 600px) {
    align-items: start;
  }
`

export const ImageContent = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  width: 100%;

  img {
    width: 100%;
    height: 315px;
    object-fit: cover;

    filter: grayscale(70%);
    transition: filter 0.3s ease-in-out;

    &:hover {
      filter: grayscale(0%);
    }

    @media (max-width: 768px) {
      height: 206px;
    }
  }

  .stack {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 10px;

    img {
      height: 152.5px;

      @media (max-width: 768px) {
        height: 98px;
      }
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    .img-11 {
      order: 9;
    }

    .stack-1 {
      order: 10;
    }
  }
`
const StyledGradientTitle = styled(GradientText)`
  ${(props) => props.theme.typography.heroHeadline};
  font-weight: 600;
  font-size: 30px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  @media (max-width: 1023px) {
    font-size: 1.375rem;
  }
`
const LifeAtRTW = () => {
  return (
    <Wrapper id={"information"}>
      <AosWrapper>
        <Container>
          <Content>
            <Headline>
              {"Life at"}
              <StyledGradientTitle>{" Ready To Work"} </StyledGradientTitle>
            </Headline>
            <Descripition>
              {
                "RTW Happy hours : unwinding and bonding after work, socializing and making \nteam bond stronger"
              }
            </Descripition>
          </Content>
          <ImageContent>
            {/* Row 1 */}
            <img src="/assets/imgs/kusum.webp" alt={`life-at-rtw-kusum`} />
            <img
              src="/assets/imgs/group-drawing.webp"
              alt={`life-at-rtw-group-drawing`}
            />
            <img src="/assets/imgs/holi.webp" alt={`life-at-rtw-holi`} />

            <div className="stack">
              <img
                src="/assets/imgs/holi-group.webp"
                alt={`life-at-rtw-holi-group`}
              />
              <img
                src="/assets/imgs/team-photo-4.webp"
                alt={`life-at-rtw-team-photo-4`}
              />
            </div>

            {/* Row 2 */}
            <div className="stack">
              <img
                src="/assets/imgs/team-photo-1.webp"
                alt={`life-at-rtw-team-photo-1`}
              />
              <img
                src="/assets/imgs/team-photo-2.webp"
                alt={`life-at-rtw-team-photo-2`}
              />
            </div>

            <img src="/assets/imgs/raj.webp" alt={`life-at-rtw-raj`} />

            <div className="stack stack-1">
              <img
                src="/assets/imgs/team-photo-3.webp"
                alt={`life-at-rtw-team-photo-3`}
              />
              <img
                src="/assets/imgs/jump-shot.webp"
                alt={`life-at-rtw-jump-shot`}
              />
            </div>

            <img
              className="img-sunil"
              src="/assets/imgs/sunil.webp"
              alt={`life-at-rtw-sunil`}
            />
          </ImageContent>
        </Container>
      </AosWrapper>
    </Wrapper>
  )
}

export { LifeAtRTW }
